export const HISTORY_SEARCH_KEYWORDS_OBAT = 'history_search_keywords_obat';
export const HISTORY_SEARCH_KEYWORDS_PENYAKIT = 'history_search_keywords_penyakit';
export const RESULT_CHECK_HEALTHTOOLS = 'result_check_healthtools';
export const CONSULTATION_FAILED_MESSAGE = 'consultation_failed_message';
export const RESULT_TANYA_OBAT = 'result_tanya_obat';
export const CONSULTATION_INSTANT_PREQUESTION = 'consultation_instant_prequestion';
export const TRANSACTION_ANALYTICS_ATTRIBUTE = 'transaction_analytics_attribute';
export const INSUFFICIENT_BENEFIT_MESSAGE = 'insufficient_benefit_message';
export const HISTORY_SEARCH_KEYWORDS_ARTICLE = 'history_search_keywords_article';
